var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAvisaequipo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 19,
    height: 20,
    fill: "#F5FBFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 7C9 5.34315 10.3431 4 12 4H25C26.6569 4 28 5.34315 28 7V9H9V7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 33C28 34.6569 26.6569 36 25 36L12 36C10.3431 36 9 34.6569 9 33L9 29L28 29L28 33Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2588 4H25.1823C26.9814 4 28.4412 5.45972 28.4412 7.25886V32.7411C28.4412 34.5403 26.9814 36 25.1823 36H12.2588C10.4597 36 9 34.5403 9 32.7411V7.25886C9 5.45972 10.4597 4 12.2588 4Z",
    stroke: "#228C80",
    strokeWidth: 1.00257,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.94617H28.4431",
    stroke: "#228C80",
    strokeWidth: 1.00257,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 29.1016H28.4431",
    stroke: "#228C80",
    strokeWidth: 1.00257,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4269 23.822C30.4269 26.8435 27.9783 29.292 24.9569 29.292C21.9355 29.292 19.4889 26.8435 19.4889 23.822C19.4889 20.8005 21.9374 18.3539 24.9569 18.3539C27.9764 18.3539 30.4269 20.8025 30.4269 23.822Z",
    fill: "#F9839A",
    stroke: "#228C80",
    strokeWidth: 1.00257,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9567 20.5062V27.1357",
    stroke: "white",
    strokeWidth: 1.00257,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2723 23.8219H21.6428",
    stroke: "white",
    strokeWidth: 1.00257,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1526 32.4174H21.6428",
    stroke: "#228C80",
    strokeWidth: 1.00257,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAvisaequipo);
export default __webpack_public_path__ + "static/media/Ic_avisa equipo.3b0b30bf7792b5669bfd2edc2e25c763.svg";
export { ForwardRef as ReactComponent };